export default "__VITE_ASSET__WQ97RHip__"